"use client";

import { SetStateAction, useState } from "react";

import { supportedFreeTranslationLanguages } from "@/app/util/languages";

const IndexPage = () => {
  const [youtubeLink, setYoutubeLink] = useState("");
  const [transcript, setTranscript] = useState("");
  const [lang, setLang] = useState("en");
  const apiUrl = process.env.NEXT_PUBLIC_API_ENDPOINT as string;

  const handleChange = (event: { target: { value: SetStateAction<string> } }) => {
    setYoutubeLink(event.target.value);
  };

  const handleLangChange = (event: { target: { value: SetStateAction<string> } }) => {
    const selectedLang = event.target.value;
    if (Object.keys(supportedFreeTranslationLanguages).includes(selectedLang as string)) {
      setLang(selectedLang);
    }
  };

  const handleSubmit = async (event: { preventDefault: () => void }) => {
    event.preventDefault();
    try {
      const response = await fetch(`${apiUrl}/subtitles/${getYoutubeVideoId(youtubeLink)}/${lang}`);
      const data = await response.json();
      setTranscript(data.transcript);
    } catch (error) {
      console.error("Error fetching transcript:", error);
    }
  };

  // Function to extract YouTube video ID from URL
  const getYoutubeVideoId = (url: string) => {
    const regex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <label>
          YouTube Link:
          <input type="text" value={youtubeLink} onChange={handleChange} />
        </label>
        <label>
          Select Language:
          <select value={lang} onChange={handleLangChange}>
            {Object.keys(supportedFreeTranslationLanguages).map(languageCode => (
              <option
                key={languageCode}
                value={supportedFreeTranslationLanguages[languageCode as keyof typeof supportedFreeTranslationLanguages]}
              >
                {languageCode}
              </option>
            ))}
          </select>
        </label>
        <button type="submit">Get Transcript</button>
      </form>
      <textarea value={transcript} rows={10} cols={50} readOnly />
    </div>
  );
};

export default IndexPage;
